import { Alert } from "./Alert"

export type HeroTextAlertProps = {
  heading: string
  message: string
}

export const HeroTextAlert = ({ heading, message }: HeroTextAlertProps) => {
  return (
    <Alert>
      <div className="flex flex-col gap-4 text-center">
        <h2 className="text-h3-np text-np-green m-0">{heading}</h2>
        <p className="text-lg">{message}</p>
      </div>
    </Alert>
  )
}
